export const phoneNumberPattern =
  /^(1|5)[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
export const urlRegex = /(https?|ftp):\/\/[^\s/$.?#].[^\s]*/gi;
